$(window).ready(function () {

    /**
     * auto-play on slick after change
     */
    $('[class^="picture-teaser-container"]')
    .on('init afterChange', function(event, slick, currentSlide, nextSlide){

        var videos = $('[data-slick] .slick-slide').find('video:not(.lazy)');
        if (videos && videos.length > 0) {

            //videos.get(0).pause();
            var current = $('[data-slick] .slick-active').find('video').get(0);

            if (!current) return;

            // autoplay muted videos
            if ($(current).prop('muted')) {

                var promise = current.play();

                if (promise !== undefined) {
                    promise.then(_ => {
                        // Autoplay started!
                    }).catch(error => {
                        // Autoplay was prevented.
                        // Show a "Play" button so that user can start playback.
                    });
                }
            }

        }

    });


    if ($('[data-slick]').length > 0 ) {
        $('[data-slick]').slick({});
    }

    /** init Homepage coverflow style news slider in slick */
    if ($('.news-teaser__list--cover').length > 0 ) {
        $('.news-teaser__list--cover').slick({
            arrows: false,
            asNavFor: '.news-teaser__list--slider',
            fade: true,
            lazyLoad: 'ondemand',
            slidesToScroll: 1,
            slidesToShow: 1,
            speed: 200
        });

        $('.news-teaser__list--slider').slick({
            arrows: true,
            asNavFor: '.news-teaser__list--cover',
            centerMode: true,
            centerPadding: '0',
            dots: false,
            focusOnSelect: true,
            infinite: false,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 576,
                    settings: {
                        asNavFor: null,
                        slidesToShow: 1
                    }
                }
            ],
            slidesToScroll: 1,
            slidesToShow: 3,
            speed: 200
        });
    }
});
